/* eslint-disable camelcase,max-len */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_ConcreteStrengthCertificate,
  ListCommandResult_ConcreteStrengthCertificate
} from "@graphql/helpers/types.graphql";
import { CommandResult, ListCommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TArchiveType,
  TConcreteStrengthCertificateType,
  TConcretingType,
  TConstructionType,
  TContractType,
  TJoin,
  TNonEmptyArray
} from "@graphql/helpers/utils.graphql";

type TConcreteStrengthCertificateByIdFunctions = {
  getByID: CommandResult_ConcreteStrengthCertificate;
};
export type TConcreteStrengthCertificateByIdQueries = {
  concreteStrengthCertificate: TConcreteStrengthCertificateByIdFunctions;
};

type TGlobal =
  | TConcreteStrengthCertificateType
  | TJoin<"archive", TArchiveType>
  | TJoin<"concreting", TConcretingType>
  | TJoin<"concreting.contract", TContractType>
  | TJoin<"concreting.contract.construction", TConstructionType>;

export const concreteStrengthCertificateById = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concreteStrengthCertificateById($id: Guid!) {
    concreteStrengthCertificate {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcreteStrengthCertificate")}
`;

type TConcreteStrengthCertificateAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ConcreteStrengthCertificate;
};
export type TConcreteStrengthCertificateAllWithPaginationQueries = {
  concreteStrengthCertificate: TConcreteStrengthCertificateAllWithPaginationFunctions;
};
export const concreteStrengthCertificateAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concreteStrengthCertificateAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    concreteStrengthCertificate {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ConcreteStrengthCertificate")}
`;

type TConcreteStrengthCertificateAllWithSortedPaginationFunctions = {
  getAllWithSortedPagination: ListCommandResult_ConcreteStrengthCertificate;
};

export type TConcreteStrengthCertificateAllWithSortedPaginationQueries = {
  concreteStrengthCertificate: TConcreteStrengthCertificateAllWithSortedPaginationFunctions;
};

export const concreteStrengthCertificateAllWithSortedPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concreteStrengthCertificateAllWithSortedPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]) {
    concreteStrengthCertificate {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ConcreteStrengthCertificate")}
`;